/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import utils from "../../utils/utils";
import "./style.less";

class PipelineProductCustomize extends React.Component {
  constructor(props) {
    super(props);
    // 初始化商品id列表数据
    const initList = props.config.itemList.map(item => {
      return {
        image: 'https://static.shihuocdn.cn/admin/files/20210406/8d9ebe0ba03eeade62495c93303d6de2.png', // 空白占位图
      };
    });
    this.state = {
      list: initList,
    };
  }

  componentDidMount() {
  }

  handleItemClick(linkUrl, index, event) {
    event.stopPropagation(); // 停止事件传播
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: linkUrl,
        props: this.props,
        index
      })
      return
    }

    const baseConfig = this.props.config.baseConfig;

    const options = {
      link: linkUrl,
      title: baseConfig.title,
      type: baseConfig.productStyle,
      sort: index,
    };
    const convertUrl = utils.convertHref(linkUrl); 
    utils.jumpToUrl(this.props.routeParams,convertUrl,linkUrl,options, '',this.props);
  }

  render() {
    const { baseConfig, itemList } = this.props.config;
    const productList = itemList || [];
    const bodyWidth = typeof window !== "undefined" ? window.document.body.clientWidth : 375;

    // 判断不同布局方式下的间距取值
    if (baseConfig.productStyle === "一行一个") {
      Object.assign(baseConfig, baseConfig.layout_1);
    } else if (baseConfig.productStyle === "一行两个") {
      Object.assign(baseConfig, baseConfig.layout_2);
    } else if (baseConfig.productStyle === "一行三个") {
      Object.assign(baseConfig, baseConfig.layout_3);
    } else if (baseConfig.productStyle === "一行一排") {
      Object.assign(baseConfig, baseConfig.layout_row);
    }

    // 转为数字处理，后续参与计算
    baseConfig.itemMargin = isNaN(Number(baseConfig.itemMargin))
      ? 0
      : Number(baseConfig.itemMargin);
    return (
      <div
        className="pipeline-product-customize"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: baseConfig.productStyle === "一行一排" ? 0 : `${baseConfig.moduleMarginHorizon}px`,
          marginBottom: this.props.showCompMarginBottom ? '8px' : '0px',
        }}
      >
        {baseConfig.showTitle && (
          <div className="title" style={{ color: baseConfig.titleColor }}>
            {baseConfig.title}
          </div>
        )}
        {baseConfig.showSubTitle && (
          <div
            className="sub-title"
            style={{ color: baseConfig.titleColor }}
            dangerouslySetInnerHTML={{ __html: baseConfig.subTitle }}
          />
        )}
        {baseConfig.productStyle !== "一行一排" ? (
          <div className="product-list">
            {productList.map((item, index) => {
              let rowItemNumber = 3; // 每行排列数量
              if (baseConfig.productStyle === "一行一个") {
                rowItemNumber = 1;
              } else if (baseConfig.productStyle === "一行两个") {
                rowItemNumber = 2;
              } else if (baseConfig.productStyle === "一行三个") {
                rowItemNumber = 3;
              }

              // 行数计算
              const currentRowIndex = Math.floor(index / rowItemNumber) + 1;
              const totalRowNum = Math.ceil(productList.length / rowItemNumber);
              const isFirstRow = Boolean(currentRowIndex === 1); // 该项是否在首行
              const isLastRow = Boolean(totalRowNum === currentRowIndex); // 该项是否在未行
              const isFirstColumn = Boolean(index % rowItemNumber === 0);
              const isLastColumn = Boolean((index + 1) % rowItemNumber === 0); // 该项是否在未列

              // 计算每个项的宽度
              const totalMargin = (rowItemNumber - 1) * baseConfig.itemMargin;
              const itemWidth = `calc((100% - ${totalMargin}px) / ${rowItemNumber})`;
              const itemStyle = {
                width: itemWidth,
                marginTop: isFirstRow ? "0" : `${baseConfig.itemMargin / 2}px`,
                marginBottom: isLastRow
                  ? "0"
                  : `${baseConfig.itemMargin / 2}px`,
                marginLeft: isFirstColumn
                  ? "0"
                  : `${baseConfig.itemMargin / 2}px`,
                marginRight: isLastColumn
                  ? "0"
                  : `${baseConfig.itemMargin / 2}px`,
              };

              let productItem;
              if (baseConfig.productStyle === "一行一个") {
                productItem = (
                  <div
                    className="product-item row-one-item"
                    key={index}
                    style={itemStyle}
                    onClick={this.handleItemClick.bind(this, item.productUrl, index)}
                  >
                    <div className="product-img-panel">
                      <LazyLoadImage
                        width={110}
                        height={110}
                        placeholder={<span className="lazy-load-placeholder" style={{display: 'inline-block', width: 110, height: 110}}></span>}
                        src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                      />
                    </div>
                    <div className="product-info">
                      <div className="info">
                        <div
                          className="name"
                          style={{ WebkitBoxOrient: "vertical" }}
                        >
                          {item.title}
                        </div>
                        {baseConfig.slogan && (
                          <div className="tag" onClick={this.handleItemClick.bind(this, item.recommendUrl, index)}>
                            {(item.recommend) && (
                              <div className="tag-text">
                                {item.recommend}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="sale">
                        <div className="price-container">
                          <div className="price">
                            <span className="rmb-icon">&yen;</span>
                            {item.price}
                          </div>
                          {baseConfig.originPrice && (
                            <span className="origin-price">
                              &yen;{item.originPrice}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              } else if (baseConfig.productStyle === "一行两个") {
                // 计算一行二商品图片宽度
                const productImgWidth = (bodyWidth - Number(baseConfig.moduleMarginHorizon) * 2 - Number(baseConfig.itemMargin)) / 2 - 6;
                productItem = (
                  <div
                    className="product-item row-two-item"
                    key={index}
                    style={itemStyle}
                    onClick={this.handleItemClick.bind(this, item.productUrl, index)}
                  >
                    <div className="product-img-panel" style={{ margin: 3 }}>
                      <LazyLoadImage
                        width={productImgWidth}
                        height={productImgWidth}
                        src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                        placeholder={<span className="lazy-load-placeholder" style={{display: 'inline-block', width: productImgWidth, height: productImgWidth}}></span>}
                      />
                    </div>
                    <div className="product-info">
                      <div className="info">
                        <div
                          className="name"
                          style={{ WebkitBoxOrient: "vertical" }}
                        >
                          {item.title}
                        </div>
                        {baseConfig.slogan && (
                          <div className="tag" onClick={this.handleItemClick.bind(this, item.recommendUrl, index)}>
                            {(item.recommend) && (
                              <div className="tag-text">
                                {item.recommend}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="sale">
                        <div className="price-container">
                          <div className="price">
                            <span className="rmb-icon">&yen;</span>
                            {item.price}
                          </div>
                          {baseConfig.originPrice && (
                            <span className="origin-price">
                              &yen;{item.originPrice}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              } else if (baseConfig.productStyle === "一行三个") {
                // 计算一行三商品图片宽度
                const productImgWidth = (bodyWidth - Number(baseConfig.moduleMarginHorizon) * 2 - Number(baseConfig.itemMargin)  * 2) / 3;
                productItem = (
                  <div
                    className="product-item row-three-item"
                    key={index}
                    style={itemStyle}
                    onClick={this.handleItemClick.bind(this, item.productUrl, index)}
                  >
                    <div className="product-img-panel">
                      <LazyLoadImage
                        width={productImgWidth}
                        height={productImgWidth}
                        src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                        placeholder={<span className="lazy-load-placeholder" style={{display: 'inline-block', width: productImgWidth, height: productImgWidth}}></span>}
                      />
                    </div>
                    <div className="product-info">
                      <div className="info">
                        <div
                          className="name"
                          style={{ WebkitBoxOrient: "vertical" }}
                        >
                          {item.title}
                        </div>
                        {baseConfig.slogan && (
                          <div className="tag" onClick={this.handleItemClick.bind(this, item.recommendUrl, index)}>
                            {(item.recommend) && (
                              <div className="tag-text">
                                {item.recommend}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="sale">
                        <div className="price">
                          <span className="rmb-icon">&yen;</span>
                          {item.price}
                        </div>
                        {baseConfig.originPrice && (
                          <span className="origin-price">
                            &yen;{item.originPrice}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                );
              }
              return productItem;
            })}
          </div>
        ) : (
          <div className="product-swiper-container">
            <div className="swiper-list">
              {productList.map((item, index) => {
                const itemStyle = {
                  paddingLeft:
                    index === 0
                      ? `${baseConfig.itemMargin}px`
                      : `${baseConfig.itemMargin / 2}px`,
                  paddingRight:
                    index === productList.length - 1
                      ? `${baseConfig.itemMargin}px`
                      : `${baseConfig.itemMargin / 2}px`,
                };
                return (
                  <div
                    className="product-item"
                    key={index}
                    onClick={this.handleItemClick.bind(this, item.productUrl, index)}
                    style={itemStyle}
                  >
                    <div className="product-img-panel">
                      <LazyLoadImage
                        width={90}
                        height={90}
                        src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                        placeholder={<span className="lazy-load-placeholder" style={{display: 'inline-block', width: 90, height: 90}}></span>}
                      />
                    </div>
                    <div className="product-name">
                      {item.title}
                    </div>
                    <div className="price-info">
                      <div className="rmb-icon">￥</div>
                      <div className="price-num">{item.price}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
}

PipelineProductCustomize.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineProductCustomize };
export default PipelineProductCustomize;



// WEBPACK FOOTER //
// ./components/pipeline-productCustomize/index.js